import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/7bba04ef-98da-498f-8ed3-bac64826a502";
export const REGISTER_URL = "https://a.ntrk2.com/062eef9a-da7a-406c-8a99-dde3a785c29e";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://mxwinwin.kzw2a.com/download?openExternalBrowser=1&id=65irqico52ghxi7";

export * from "./codes";
export * from "./context";
